export const INITIAL_VISIBLE_EVENTS = 10;
